"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _RadioGroup = _interopRequireDefault(require("@material-ui/core/RadioGroup"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var SttRadioGroup = function SttRadioGroup(props) {
  return /*#__PURE__*/_react["default"].createElement(_RadioGroup["default"], props);
};
var _default = SttRadioGroup;
exports["default"] = _default;